import { PersonAppearance } from '@app/modules/persons/appearances/types';

/** Stable id for hover sync between the detail timeline and appearance list. */
export function personAppearanceKey(a: PersonAppearance): string {
  return `${a.source}-${a.from}-${a.to}`;
}
